/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import moment from 'moment-timezone';
import { task } from 'ember-concurrency';
import { timeout } from 'ember-concurrency';

import TIME_ZONES from 'cio/utils/time-zones';

import AnalyticsService from 'cio/services/analytics';
import NewsletterModel from 'cio/models/newsletter';
import { TimeZoneOptionType } from 'cio/components/cio-schedule-editor';

// eslint-disable-next-line spellcheck/spell-checker
const TIME_FORMAT = 'h:mma on MMM D, YYYY';

interface TimeZonePickerArgs {
  hasTestSetup: boolean;
  newsletter: NewsletterModel;
  onTimeZoneOptionSelected: () => undefined;
  rateLimitedSendDuration: moment.Duration;
  sendTimeZoneOption: TimeZoneOptionType;
  time: moment.Moment;
  timezone: string;
}

export default class TimeZonePicker extends Component<TimeZonePickerArgs> {
  @service analytics!: AnalyticsService;

  newsletter!: NewsletterModel;

  get _userOptionDisabled() {
    return this.args.rateLimitedSendDuration || this.args.hasTestSetup;
  }
  get _inputTime() {
    return this.args.time.creationData().input;
  }
  get _timeZones() {
    return TIME_ZONES;
  }
  get _userOptionDisabledTooltip() {
    let content = '';

    if (!this._userOptionDisabled) {
      return;
    }

    if (this.args.rateLimitedSendDuration && this.args.hasTestSetup) {
      content = 'You cannot choose User Time Zone Match when you have a send rate limit or a Newsletter test.';
    } else if (this.args.rateLimitedSendDuration) {
      content = 'You cannot choose User Time Zone Match when you have a send rate limit.';
    } else if (this.args.hasTestSetup) {
      content = 'You cannot choose User Time Zone Match when you have a Newsletter test.';
    }

    return content;
  }
  get _nextDeliveryTimeHumanReadable() {
    return moment(this._inputTime).add(1, 'd').format(TIME_FORMAT);
  }
  get _showTimeZoneWarning() {
    return moment.parseZone(`${this._inputTime}+14:00`).isBefore(moment());
  }

  trackUserTimeZoneSendingHover = task({ restartable: true }, async () => {
    if (!this._userOptionDisabled) {
      return;
    }

    await timeout(250);

    this.analytics.track('broadcast', 'edit_started', {
      editType: 'tz_disabled_hovered',
      model: this.newsletter,
    });
  });

  @action
  cancelTrackUserTimeZoneSendingHover() {
    this.trackUserTimeZoneSendingHover.cancelAll();
  }

  constructor(owner: unknown, args: TimeZonePickerArgs) {
    super(owner, args);
    this.newsletter = args.newsletter;
  }
}
